import { getOrder } from './get-order';
export const hasOrderBeenCreated = () => !!getOrder();
